import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_get_report_dataService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { module_id: string, report_id: string, in_params: any, type: $frontendTypes.Notifications.e_report_file_type }): Promise<{ report_data_url?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.module_id)) {
      $missingRequiredInParams.push('\'module_id\'');
    }
    if (isNil($inParams.report_id)) {
      $missingRequiredInParams.push('\'report_id\'');
    }
    if (isNil($inParams.in_params)) {
      $missingRequiredInParams.push('\'in_params\'');
    }
    if (isNil($inParams.type)) {
      $missingRequiredInParams.push('\'type\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

